import {
  Context,
  useCartFactory,
  UseCartFactoryParams
} from '@vue-storefront/core';
import type {
  Cart,
  CartItem,
  Product
} from '@bee-hole/api';
import { useApiError } from '../useApiError';

const params: UseCartFactoryParams<Cart, CartItem, Product> = {
  provide: () => ({
    useApiError: useApiError()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  load: async (context: Context, {customQuery}): Promise<Cart> => {
    let result = null;
    try {
      result = await context.$xbuy.api.customCartLoad({});
    } catch (err) {
      console.log('异常', err);
    }
    // if (result && result.code && result.code > 0) {
    //   context.useApiError.set(result);
    //   throw new Error(result.message);
    // }
    const cart: Cart = {
      list: result.data?.list ? result.data.list : [],
      total: result.data?.list ? result.data.list.lengh : 0,
      setType: result.data?.settype ? result.data.set_type : 0
    };
    return cart;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addItem: async (context: Context, { currentCart, product, quantity, customQuery }) => {
    let skuId = 0;
    if (!(!product || !product.skus || product?.skus?.length === 0)) {
      skuId = product.skus[0].skuId;
    }
    if (!(!customQuery || !customQuery.skuId)) {
      skuId = Number(customQuery.skuId);
    }
    const x = { sku_id: skuId, num: quantity, good_id: product.goodId };
    const data = await context.$xbuy.api.customAddCart(x);
    context.useApiError.set(data);

    if (data && data.code && data.code > 0) {
      throw new Error(data.message);
    }
    const res = await params.load(context, {});
    return res;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeItem: async (context: Context, { currentCart, product, customQuery }) => {
    const paramsData = { skuId: customQuery?.sku_id };
    const removeRes = await context.$xbuy.api.customCartRemove(paramsData);
    if (removeRes && removeRes.code && removeRes.code > 0) {
      context.useApiError.set(removeRes);
      throw new Error(removeRes.message);
    }
    const loadData = await params.load(context, {});
    return loadData;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateItemQty: async (context: Context, { currentCart, product, quantity, customQuery }) => {
    const paramsData = { skuId: product?.skuId, num: quantity };
    // console.log('----------Mocked', paramsData);
    // console.log('paramsData----------------', paramsData)
    if (!customQuery.refresh) {
      const updateRes = await context.$xbuy.api.customUpdateCart(paramsData);
      if (updateRes && updateRes.code && updateRes.code > 0) {
        context.useApiError.set(updateRes);
        throw new Error(updateRes.message);
      }
    }
    const loadData = await params.load(context, {});
    // console.log('更新结果查询', loadData)
    return loadData;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  clear: async (context: Context, { currentCart }) => {
    // console.log('Mocked: useCart.clear');
    const result = await context.$xbuy.api.customClearCart();

    if (result && result.code && result.code > 0) {
      context.useApiError.set(result);
      throw new Error(result.message);
    }
    // console.log('清空结果-----------', data);
    const loadData = await params.load(context, {});
    return loadData;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  applyCoupon: async (context: Context, { currentCart, couponCode, customQuery }) => {
    // console.log('Mocked: useCart.applyCoupon');
    const loadData = await params.load(context, {});
    return {
      updatedCart: loadData
    };
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeCoupon: async (context: Context, { currentCart, couponCode, customQuery }) => {
    // console.log('Mocked: useCart.removeCoupon');
    const loadData = await params.load(context, {});
    return {
      updatedCart: loadData
    };
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isInCart: (context: Context, { currentCart, product }) => {
    // console.log('Mocked: useCart.isInCart');
    return false;
  }
};

export const useCart = useCartFactory<Cart, CartItem, Product>(params);
